/**
 * Centralized navigation configuration.
 * Used by SiteHeader, SiteFooter, MobileNav, and Breadcrumbs.
 */

export type NavItem = {
  label: string;
  to: string;
  description?: string;
  children?: NavItem[];
};

export const mainNav: NavItem[] = [
  {
    label: "Home",
    to: "/",
    description: "Botanical sanctuary homepage",
  },
  {
    label: "Shop",
    to: "/shop",
    description: "Browse all botanical pieces",
    children: [
      { label: "All Products", to: "/shop" },
      { label: "Indoor Plants", to: "/shop?category=indoor-plants" },
      { label: "Hanging Plants", to: "/shop?category=hanging-plants" },
      { label: "Artificial Trees", to: "/shop?category=artificial-trees" },
      { label: "Green Walls", to: "/shop?category=green-walls" },
      { label: "Home Décor", to: "/shop?category=home-decor" },
    ],
  },
  {
    label: "Collections",
    to: "/collections",
    description: "Curated sets, styled room by room",
  },
  {
    label: "Journal",
    to: "/blog",
    description: "Styling guides and botanical stories",
  },
  {
    label: "About",
    to: "/about",
    description: "Our studio, materials & craft",
  },
];

export type FooterColumn = {
  title: string;
  items: { label: string; to: string }[];
};

export const footerNav: FooterColumn[] = [
  {
    title: "Shop",
    items: [
      { label: "Indoor Plants", to: "/shop?category=indoor-plants" },
      { label: "Hanging Plants", to: "/shop?category=hanging-plants" },
      { label: "Artificial Trees", to: "/shop?category=artificial-trees" },
      { label: "Green Walls", to: "/shop?category=green-walls" },
      { label: "Home Décor", to: "/shop?category=home-decor" },
    ],
  },
  {
    title: "Studio",
    items: [
      { label: "Our Story", to: "/about" },
      { label: "Materials", to: "/about#materials" },
      { label: "Collections", to: "/collections" },
      { label: "Journal", to: "/blog" },
    ],
  },
  {
    title: "Support",
    items: [
      { label: "Shipping & Returns", to: "/shipping" },
      { label: "FAQs", to: "/faq" },
      { label: "Contact Us", to: "/contact" },
      { label: "Track Order", to: "/account/orders" },
    ],
  },
];
